<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {

    }
  },
  created() {


  }
}
</script>

<style>
#app {
  height: 100%;
}

ul,
li {
  list-style: none;
  padding: 0;
  margin: 0;
}

.my-pagination {
  /* height: 80px; */
  display: flex;
  align-items: center;
  padding-top: 16px;
  justify-content: center;
}

.my-right-wrap {
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 6px;
  height: calc(100vh - 100px);
  overflow: hidden;
}

.my-right-scroll {
  background: #fff;
  padding: 20px;
  padding-top: 10px;
  box-sizing: border-box;
  border-radius: 6px;
  height: calc(100vh - 142px);
  overflow: hidden;
}

.my-right-tit {
  font-weight: bold;
  font-size: 20px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.my-tabs {
  height: calc(100% - 70px);
}

.my-tit {
  border-bottom: 1px dashed #ccc;
  padding: 20px 0;
  margin-bottom: 20px;
  font-weight: bold;
}

.my-tit span {
  padding-left: 10px;
}

/* 去掉动画 */
.el-upload-list__item {
  transition-duration: 0.3s;
}

/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
.el-button--primary {
  background: #1a1919 !important;
  border-color: #1a1919 !important;
}

.el-button--primary:focus,.el-button--primary:hover{
background: #1a1919;
border-color: #1a1919;
color: #fff;
}

/* .el-button:focus,
  .el-button:hover, */
.el-button--default:focus,
.el-button--default:hover,
.el-button--primary.is-plain:focus,
.el-button--primary.is-plain:hover,
.el-button--primary.is-plain {
  color: #1a1919 !important;
  border-color: #C0C4CC !important;
  background-color: #ececec !important;
}


.el-button--primary.is-disabled,
.el-button--primary.is-disabled:active,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:hover {
  background: #6c6b6b !important;
  border-color: #6c6b6b !important;
  color: #fff !important;
}


.el-input.is-active .el-input__inner,
.el-input__inner:focus,
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus,
.el-cascader .el-input .el-input__inner:focus,
.el-cascader .el-input.is-focus .el-input__inner {
  border-color: #C0C4CC;
}

.el-button--text,
.el-button--text:focus,
.el-button--text:hover {
  color: #1a1919;
  background-color: transparent;
  border-color: transparent;
}

.el-button--danger.is-plain {
  color: #F56C6C;
  background: #ffffff;
  border-color: #fbc4c4;
}

.el-button--danger.is-plain:active {
  background: #ffffff;
  /* border-color: #dd6161; */
  border-color: #fbc4c4;
  color: #F56C6C;
  outline: 0;
}

.el-button--danger.is-plain:focus,
.el-button--danger.is-plain:hover {
  background: #ffffff;
  /* background: #F56C6C; */
  border-color: #F56C6C;
  color: #F56C6C;
}

.el-range-editor.is-active,
.el-range-editor.is-active:hover {
  border-color: #C0C4CC;
}

.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #777777;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1a1919;
  color: #FFF;
}

.el-pagination__sizes .el-input .el-input__inner:hover,
.el-textarea__inner:focus {
  border-color: #C0C4CC;
}

.el-menu-item.is-active {
  color: #1a1919;
  background-color: #eeeeee;
}

.el-menu-item:focus,
.el-menu-item:hover {
  background-color: #eeeeee;
}

.el-tabs__item.is-active {
  color: #1a1919;
  font-weight: 700;
}

.el-tabs__item:hover {
  color: #1a1919;
}

.el-tabs__active-bar {
  background-color: #1a1919;
}

.el-tag--dark {
  background-color: #1a1919;
  border-color: #1a1919;
}

.el-switch__label {
  color: #DCDFE6;
}

.el-switch__label.is-active {
  color: #1a1919;
}

.el-radio__input.is-checked .el-radio__inner {
  border-color: #1a1919;
  background: #1a1919;
}

.el-radio__input.is-checked+.el-radio__label {
  color: #1a1919;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #1a1919;
  border-color: #1a1919;

}

.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #1a1919;
}

.el-checkbox__inner:hover,
.el-radio__inner:hover,
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #1a1919;
}

.el-step__head.is-finish {
  color: #1a1919;
  border-color: #1a1919;
}

.el-step__title.is-finish,
.el-step__description.is-finish {
  color: #1a1919;
}

.el-table__body tr.current-row>td,
.el-table--striped .el-table__body tr.el-table__row--striped.current-row td {
  background-color: #eeeeee;
}

.el-tabs__nav-next,
.el-tabs__nav-prev {
  line-height: 40px;
  font-size: 28px;
}

/* .my-loading */
.el-loading-spinner .el-loading-text {
  color: #fff;
}

/*  .my-loading  */
.el-loading-spinner .path {
  stroke: #fff;
}

.el-loading-mask .el-loading-spinner i,
.el-loading-spinner .el-loading-text {
  color: #FFFFFF !important;
}

/* 对element UI dialog样式修改 */
.el-dialog__header {
  border-bottom: 1px solid #F1F1F1;
  padding: 10px 20px;
}

.el-dialog__body {
  padding: 0px 20px;
}

.el-dialog__footer {
  border-top: 1px solid #F1F1F1;
  padding: 10px 0;
}

/* 修改滚动条样式 begin*/
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 8px;
  height: 8px
}

/*定义滚动条轨道*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgb(0 0 0 / 20%);
  border-radius: 10px;
  background: #fff;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  background-color: #aaa;
  -webkit-box-shadow: inset 0 0 5px rgb(0 0 0 / 20%);
  /* background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent); */
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}

/* 修改滚动条样式 end*/

/* 普通dialog style 修改 */
.to-view-dialog .el-dialog__header {
  border-bottom: 1px solid #F1F1F1;
  padding: 10px 20px;

}

.to-view-dialog .el-dialog__body {
  padding: 20px 20px;
}

.table {
  border: 1px solid #EBEEF5;
  border-bottom: none;
}

.el-statistic {
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #000;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  text-align: center;
  border-right: 1px solid #e8eaec;
}



.el-statistic .head {
  margin-bottom: 4px;
  color: #606266;
  font-size: 13px
}

.el-statistic .con {
  font-family: Sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #303133;
  margin-top: 10px;
}

.el-statistic .con .number {
  font-size: 20px;
  padding: 0 4px
}

.el-statistic .con span {
  display: inline-block;
  margin: 0;
  line-height: 100%
}
</style>



// WEBPACK FOOTER //
// src/App.vue